import { useMask } from '@react-input/mask';

import { TextInput } from '../TextInput';

export const InputPhone = props => {
  const ref = useMask({
    mask: '+1 ___ ___ ____',
    replacement: { _: /\d/ },
  });

  return <TextInput ref={ref} {...props} />;
};
